import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import * as Constants from "../../models/Constants";
import {ApplicationService} from "../../shared/services/application.service";
import {AlertService} from "../../shared/services/alert.service";
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-generate-certificate-modal',
  templateUrl: './generate-certificate-modal.component.html',
  styleUrls: ['./generate-certificate-modal.component.css']
})
export class GenerateCertificateModal implements OnInit {

  @Input() title: string;
  @Input() buttonLabel: string;
  @Input() applicationId: number;
  @Input() newApplicationStatus: string;
  constants: any = Constants;
  @Output() certificateGenerated = new EventEmitter<boolean>(); // to send data to the parent
  @Input() specificProductExists : boolean; 

  constructor(private applicationService: ApplicationService, private alertService: AlertService, private spinner: NgxSpinnerService) { 
  }


  ngOnInit() {
    console.log(this.specificProductExists);
  }

  submitForm(appId, proclamationNumber, productCode) {
    const data = {
      'applicationID': parseInt(appId.value),
      'declarationNumber': proclamationNumber.value,
      'productTypeNumber': this.specificProductExists ? "" : productCode.value
    };
    this.spinner.show();
    $('#generateCertificateModal').modal('hide');
    this.applicationService.generateCertificate(data).subscribe(
      response => {
        this.spinner.hide();
        if (response) {
          this.certificateGenerated.emit(true);
          this.alertService.success('Certificate generated successfully. Wait 30 seconds to print the certificate.');
        } else {
          this.alertService.error('Certificate Generation Failed.');
        }
      }, err => {
        this.spinner.hide();
        this.alertService.error(err);
      });
  }
}
